import { ProgressProps } from '@ui-components/neo.tax';
import { FormEvent } from 'react';

import { FormType, YesNo } from './forms.enums';
import { Form } from './forms.types';

// translate YesNo enum to boolean
export const toBoolean = (value: YesNo | null | undefined): boolean | null => {
  if (value === YesNo.YES || value === YesNo.NO) {
    return value === YesNo.YES;
  }
  return null;
};

// translate boolean to YesNo enum
export const toYesNoEnum = (value: boolean | null | undefined): YesNo | undefined => {
  if (value === true) return YesNo.YES;
  if (value === false) return YesNo.NO;
  return undefined;
};

const updateAnswerStats = (form: Form, answerStats: ProgressProps): ProgressProps => {
  if (form.formType === FormType.FORM_TITLE || form.optional) {
    return answerStats;
  }

  answerStats.total++;

  switch (form.formType) {
    case FormType.YES_NO:
    case FormType.TEXT_AREA:
    case FormType.DROPDOWN:
    case FormType.BUTTON_GROUP:
    case FormType.MONTH_DATE_PICKER:
      if (form.value) {
        answerStats.completed++;
      }
      break;
    case FormType.CHECKBOXES:
      if (form.value.size > 0) {
        answerStats.completed++;
      }
      break;
    case FormType.INPUT:
      if (form.value !== undefined && form.value !== null && form.value !== '' && !form.validator?.(form.value)) {
        answerStats.completed++;
      }
      break;
    default:
      break;
  }

  return answerStats;
};

export const getProgress = (
  forms: Array<Form | Array<Form>>,
  initialValue: ProgressProps = { total: 0, completed: 0 },
): ProgressProps =>
  forms.reduce((acc, curr): { total: number; completed: number } => {
    if (Array.isArray(curr)) return curr.reduce((acc, curr) => updateAnswerStats(curr, acc), acc);
    acc = updateAnswerStats(curr, acc);
    if (curr.subForms) {
      acc = getProgress(curr.subForms, acc);
    }
    return acc;
  }, initialValue);

export const saveQuestions = async <T,>({
  invalid,
  questionsInput,
  setState,
  updateQuestions,
}: {
  setState: (value: React.SetStateAction<T>) => void;
  updateQuestions: (input: Partial<T>) => Promise<void> | undefined;
  questionsInput: Partial<T>;
  invalid?: boolean;
}): Promise<void> => {
  setState((newState) => ({
    ...newState,
    ...questionsInput,
  }));
  if (invalid) return;
  await updateQuestions(questionsInput);
};

export const noopFormSubmit = (event: FormEvent<HTMLFormElement>): void => {
  event.preventDefault();
};
